import { useLayoutEffect as e, useState as t } from "react";
//#region src/components/overlay/useOverlayArrowPlacement.ts
var n = (e) => ({
	arrowPlacement: e,
	arrowOffsetInline: 0,
	arrowOffsetBlock: 0
}), r = ({ placement: r, show: o, triggerElement: s, overlayElement: c }) => {
	let [l, u] = t(() => n(r));
	return e(() => {
		u(n(r));
	}, [r, o]), e(() => {
		if (!o || !s || !c) return;
		let e = 0, t = 0, n = () => {
			window.cancelAnimationFrame(e), window.cancelAnimationFrame(t);
		}, l = () => {
			let e = i(r, s.getBoundingClientRect(), c.getBoundingClientRect());
			u((t) => a(t, e) ? t : e);
		}, d = () => {
			n(), e = window.requestAnimationFrame(() => {
				l(), t = window.requestAnimationFrame(l);
			});
		};
		return d(), window.addEventListener("resize", d), window.addEventListener("scroll", d, !0), () => {
			n(), window.removeEventListener("resize", d), window.removeEventListener("scroll", d, !0);
		};
	}, [
		o,
		r,
		s,
		c
	]), l;
}, i = (e, t, r) => {
	if (!o(t) || !o(r)) return n(e);
	let i = t.left + t.width / 2, a = t.top + t.height / 2, l = r.left + r.width / 2, u = r.top + r.height / 2, d = c(e), f = d === "top" || d === "bottom" ? u < a ? "top" : "bottom" : l < i ? "left" : "right";
	return {
		arrowPlacement: `${f}${s(e)}`,
		arrowOffsetInline: f === "top" || f === "bottom" ? i - l : 0,
		arrowOffsetBlock: f === "left" || f === "right" ? a - u : 0
	};
}, a = (e, t) => e.arrowPlacement === t.arrowPlacement && e.arrowOffsetInline === t.arrowOffsetInline && e.arrowOffsetBlock === t.arrowOffsetBlock, o = (e) => e.width > 0 || e.height > 0, s = (e) => e.endsWith("-start") ? "-start" : e.endsWith("-end") ? "-end" : "", c = (e) => e.split("-")[0];
//#endregion
export { r as useOverlayArrowPlacement };

//# sourceMappingURL=useOverlayArrowPlacement.js.map